import React from "react";
import {Switch, Redirect, Route} from "react-router-dom";

import Image_Compression from "./components/Image_Compression";
import ErrorBoundaryRoute from "../../../../containers/ErrorBoundaryRoute";

/*
	Exact index route, then fallback Redirect for unknown subpaths (same idea as davidsons_products).
	Redirect is not placed as a direct child of ErrorBoundaryRoute: that helper uses cloneElement(children)
	and breaks <Redirect />.
 */
export default ({
	match,
	locations,
	states,
	reloadShell,
	userAccess,
	hasImageCompressionModule,
}) => (
	<div>
		<Switch>
			{hasImageCompressionModule ? (
				<ErrorBoundaryRoute exact path={`${match.path}`}>
					<Image_Compression
						locations={locations}
						states={states}
						reloadShell={reloadShell}
						userAccess={userAccess}
					/>
				</ErrorBoundaryRoute>
			) : (
				<Route exact path={`${match.path}`} render={() => <Redirect to="/dashboard" />} />
			)}
			<Route render={() => <Redirect to="/image_compression" />} />
		</Switch>
	</div>
);
